export * from './apiConfig';
export * from './urlPattern';
export * from './leaseSteppingId';
export * from './purchaseOptionsIds';
export * from './date';
export * from './users';
export * from './titles';
export * from './searchInputDelay';
export * from './email';
export * from './autoRenewTerms';
export * from './termsAndConditionsLink';
export * from './autoRenewDialogsTexts';
export * from './productIds';
export * from './phoneValidationMessages';
export * from './subProductLineIds';
export * from './supportIds';
export * from './productLineIds';

export const DONGLE_UPDATE_TYPES_EMERGENCY_CODE_GENERATED = 'Emergency code generated';

export const EMAIL_OTP_EXPIRATION_TIME = 10; // in minutes

export const itemsPerPageOptions = [
  { value: 15, title: '15' },
  { value: 50, title: '50' },
  { value: 100, title: '100' },
];

export const MINIMUM_CHARACTERS_TO_CHANGE_EXPIRY_DATE = 16;
